export default function ContactHero() {
  return (
    <section className="relative min-h-[85vh] flex flex-col items-center justify-center overflow-hidden">
      {/* Background image - facility exterior from source */}
      <div className="absolute inset-0">
        <img
                  src="/images/mm1.png"
          alt=""
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-primary-900/85" />
      </div>

      {/* Content */}
      <div className="relative z-10 text-center px-4 py-16 w-full">
        <p className="font-script text-base md:text-lg text-white/90 mb-3">
          America's One-Stop-Shop for Seafood
        </p>
        <h1 className="font-heading text-4xl sm:text-5xl md:text-6xl lg:text-7xl text-white tracking-[0.2em] mb-8">
          CONTACT US
        </h1>

        <div className="max-w-2xl mx-auto">
          <img
                      src="/images/logo.png"
            alt="FKS Facility Lobby"
            className="w-full h-auto object-contain"
          />
        </div>

        <div className="mt-10 flex flex-col items-center gap-1">
          <span className="text-[10px] tracking-[0.3em] uppercase text-white/80 font-medium">
            SCROLL
          </span>
          <i className="ri-arrow-down-s-line text-xl text-white/80" />
        </div>
      </div>
    </section>
  );
}